import React from 'react';
import {getFriendlyTeamName, getTeamEventUrl} from '../../../utils/gameUtils';
import {
    Link,
    useParams,
} from "react-router-dom";
import {formatGameTime} from '../../../utils/timeFormat'
import {makeStyles, useTheme} from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import {TeamImage as TeamImageWrapper} from '../../odds/TeamImage';

const styles = makeStyles(theme => ({
    container: {
        flex: 1,
        display: 'grid',
        height: '100%',
        width: '100%',
        gridTemplateColumns: '30px, 1fr',
        gridTemplateRows: '1fr, 1fr, 1fr',
        justifyItems: 'left',
        alignItems: 'center',
        [theme.breakpoints.up("sm")]: {
            gridTemplateColumns: '40px 1fr',
            gridAutoRows: '1fr 1fr',
        }
    },
    teamName: {
        fontSize: 14,
        fontWeight: 600,
        letterSpacing: '0.3px',
        textAlign: 'left',
        [theme.breakpoints.down('sm')]: {
            fontSize: 14,
            marginTop: '5px',
        },
        "& p": {
            color: 'black !important',
        },
        marginLeft: 4,
        justifySelf: 'start',
        marginBottom: 0,
        marginTop: 0,
    },
    teamImage: {
        width: 30,
        height: 30,
        objectFit: 'contain',
    },
    gameDate: {
        fontSize: 12,
        fontWeight: 400,
        textAlign: 'center',
        gridColumn: "1 / 3",
        [theme.breakpoints.up("sm")]: {
            fontSize: '14px',
            fontWeight: 600,
            gridColumn: 'auto'
        }
    },
    allButton: {
        maxWidth: 30,
        maxHeight: 14,
        marginRight: '35%',
        '& img': {
            maxHeight: '100%',
            maxWidth: '100%',
        }
    },
    openerDiv: {
        width: '90px',
        maxHeight: '20px',
        justifyContent: 'center',
    }
}));

export function TeamMatchup({game}) {
    const classes = styles();
    const theme = useTheme();
    const isLargeScreen = useMediaQuery(theme.breakpoints.up('sm'));
    const {league} = useParams();

    const homeTeam = game.competitors['home'];
    const awayTeam = game.competitors['away'];
    const gameTimeDate = new Date(game['scheduled_datetime']);
    const gameTime = formatGameTime(gameTimeDate);

    let url = getTeamEventUrl(league, game);

    if (isLargeScreen) {
        return (
            <div className={classes.container}>
                <TeamImage competitor={awayTeam} league={league}/>
                <TeamName competitor={awayTeam} league={league}/>
                <TeamImage competitor={homeTeam} league={league}/>
                <TeamName competitor={homeTeam} league={league}/>
            </div>
        );
    }

    return (
        <Link to={url}>
            <div className={classes.container}>
                <TeamImage competitor={awayTeam} league={league}/>
                <TeamName competitor={awayTeam} league={league}/>
                <TeamImage competitor={homeTeam} league={league}/>
                <TeamName competitor={homeTeam} league={league}/>
                <GameDate gameStatus={game.status} gameTime={gameTime}/>
            </div>
        </Link>
    );
}

const TeamName = ({competitor, league}) => {
    const classes = styles();
    return <p className={classes.teamName}>{getFriendlyTeamName(league, competitor)}</p>
}

const TeamImage = ({competitor, league}) => {
    const classes = styles();
    return <TeamImageWrapper className={classes.teamImage} competitor={competitor} league={league}/>
}

const GameDate = ({gameStatus, gameTime}) => {
    const classes = styles();
    return <p className={classes.gameDate}>{gameStatus === 'postponed' ? 'Postponed' : gameTime.toString()}</p>
}